// Libraries
import React from 'react'
import getQueryVariable from '~/tools/getQueryVariable'
import Link from '~/components/Link'
import _ from 'lodash'
import { TriangleIcon, FiltersSVG } from '~/assets/svg/index'
import DropdownIcon from './DropdownIcon';

import popup from '~/views/Popup/popup'
import avatar from '~/assets/images/avatar.png'

import { logout } from '~/redux/user/helpers'
import accessLevelCheck from '~/tools/accessLevelCheck'
import makeSticky from '~/tools/sticky'
import resize from '~/tools/resize'
import { logoutUser } from '~/tools/analytics/cleverTap'
import { userLanguageSelector } from '~/tools/localization'

import pageStore from '~/redux/page/store'
import { fetchPage } from '~/redux/page/actions'
import LanguageDropdown from './LanguageDropdown'
import SearchFilterSlideIn from './SearchFilterSlideIn/index'

import connect from '~/tools/connect'
import userStore from '~/redux/user/store'
import { fetchModels } from '~/redux/models/helpers'

import './style.scss'
import { localizeTitle, localizeCtaText, localizeBannerText } from '~/tools/localization'

class Masthead01 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mobileMenuOpen: false,
      searchFiltersOpen: false,
      openMobileSubmenus: [],
      links: _.get(window.settings, 'navigation.primary', []),
      userLinks: _.get(window.settings, 'navigation.user', [])
    }
    
    this.primaryCta = _.get(window, 'settings.navigation.settings.primaryCta') || {}

    this.pushButtonEvent = this.pushButtonEvent.bind(this)
  }

  async componentDidMount(){
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
    this.setState({ model: await fetchModels() })
  }

  handleScroll = () => {
    if (this.masthead) makeSticky(this.masthead)
  }

  handleResize = () => {
    if (this.masthead) resize(this.masthead)
    if (window.innerWidth >= 1025 && this.state.mobileMenuOpen) this.toggleMobileMenu()
  }

  chooseLang = lang => e => {
    let route = window.location.pathname
    if (route.length > 1) route = route.replace(/\/$/, '')
    pageStore.dispatch(fetchPage(route, lang))
  }

  renderLanguageDropdown = () => {
    const langs = window.settings.languages;
    if (langs) {
      const { languages } = langs,
        chosenLangCode = userLanguageSelector(),
        langProps = {
          languages,
          chosenLangCode,
          defaultLang: langs.default,
          chooseLanguage: this.chooseLang
        }
      return <LanguageDropdown {...langProps} />
    }
  };

  handleSearch = () => {
    if (this.props.filtersSearch) {
      return () => {
        this.setState(({ searchFiltersOpen }) => ({
          searchFiltersOpen: !searchFiltersOpen
        }));
      };
    }
    return _ => popup.search();
  }

  toggleFilterMenu = () =>
    this.setState(({ searchFiltersOpen }) => ({ searchFiltersOpen: !searchFiltersOpen }))

  shouldRenderBanner() {
    if (window.SERVER_SIDE_RENDERING)
      return false
    if (this.primaryCta.placement !== 'Banner')
      return false
    if (this.state.user && this.state.user.isSubscribed)
      return false
    if (this.props.layout.settings.isBannerHidden)
      return false

    return true
  }
  
  renderStaticLogo = () => {
    return (
      <Link href={this.state.user && window.settings.forceLogin ? "/home" : "/"} className="logo">
        <img className="logo-image" src={ _.get(window.settings, 'images.desktopLogo') } alt="Logo" />
      </Link>
    );
  };

  renderMasthead() {
    // partially apply the user for readability / micro-performance
    const checkUserAccessLevel = accessLevelCheck(this.state.user)
    const isSVOD = this.state.model === 'SVOD'
    const linkAlignment = _.get(this.props.layout, 'settings.linkAlignment')

    return (
      
      <header>
        <div className={`large-version ${linkAlignment && linkAlignment}`}>
          <div className="logo-container">
            <Link href={(this.state.user && window.settings.forceLogin) ? "/home": "/"} className="logo" >
              <img className="logo-image" src={ _.get(window.settings, 'images.desktopLogo') } alt="Logo" />
            </Link>
          </div>

          <nav className="navigation">
            { this.state.links
              .filter(checkUserAccessLevel)
              .map((l,i) => this.renderMenu(l,i))
            }
            { this.props.filtersSearch && 
              <div className="menu-dropdown-container">
                <span>
                  <a className="navigation-link">
                    <span onClick={ this.handleSearch() }>
                      Filter
                    </span>
                  </a>
                </span>
              </div> 
            }
          </nav>
        </div>

        <div className="small-version">
          <nav className={
            'mobile-nav ' + (this.state.mobileMenuOpen ? 'open ' : '') +
            (this.state.user ? 'logged-in ': 'logged-out ') + 'mobile-nav-header '
          }>
            <img className="mobile-logo" src={ _.get(window.settings, 'images.desktopLogo') } alt={window.settings.site} />
            <div className="mobile-navigation-links">
              {this.state.links
                .filter(checkUserAccessLevel)
                .map((l, i) => this.renderMenu(l, i))}
              {this.renderLanguageDropdown()}
            </div>
            <div>
              {this.state.user
                ? (
                  <div className="mobile-navigation-links">
                    {this.state.userLinks
                      .filter(checkUserAccessLevel)
                      .map((l, i) => this.renderUserMenu(l,i))}
                    <div className="menu-dropdown-container" key="logout">
                      <a className="navigation-link" href="#logout" onClick={ e => this.onLogoutClick(e) }>Log Out</a>
                    </div>
                  </div>
                )
                : (
                  <div className="logged-out-container">
                    <p className="navigation-link logged-out-message">Currently Logged Out</p>
                    <button className="cta secondary" onClick={evt => { popup.login() }}>Log In</button>
                    { isSVOD &&
                      <a
                        href="/viewplans"
                        className="cta primary"
                        onClick={ () => this.pushButtonEvent('masthead-button') }
                      >
                        Subscribe Now
                      </a>
                    }
                  </div>
                )}
            </div>
          </nav>
          <div className={'mobile-header ' + (this.state.mobileMenuOpen ? 'move' : '')}>
            <div className="mobile-menu" onClick={ _ => this.toggleMobileMenu() }>
                { this.state.mobileMenuOpen 
                  ? <i className="navigation-link ion-close"/>
                  : <i className="navigation-link ion-navicon"/>
                }              
            </div>
            <div className="logo">
              <a href="/">
                <img src={ _.get(window.settings, 'images.desktopLogo')} alt={window.settings.site} />
              </a>
            </div>
          </div>
          { <div className={`search-icon ${this.state.mobileMenuOpen ? 'move' : ''}` } onClick={ this.handleSearch() } >
            { this.props.filtersSearch ? <FiltersSVG className="filters"/> : <i className="navigation-link ion-ios-search-strong" /> }
          </div>}
          { isSVOD && !(this.state.user && this.state.user.isSubscribed) && this.subscribeButton() }
        </div>

        {window.settings.forceLogin ? this.state.user && this.controlButtons() : this.controlButtons() }
      </header>
    )
  }

  isSubmenuOpen = title => this.state.openMobileSubmenus.includes(title)

  toggleMobileSubmenu = title => {
    return e => {
      this.setState(({ openMobileSubmenus: prevOpenSubmenus }) => {
        const newOpenSubmenus = this.isSubmenuOpen(title) ?
          prevOpenSubmenus.filter(m => m !== title) :
          prevOpenSubmenus.concat(title);
        return {
          openMobileSubmenus: newOpenSubmenus
        }
      })
    }
  }

  renderMenu(menuItem, key) {
    const path = window.location.pathname;
    const active = (path === menuItem.url || ((path !== "") && path.indexOf(menuItem.title.toLowerCase()) !== -1))
    const localizedTitle = localizeTitle(menuItem)
    const linkColor = _.get(window.settings, "brand.navigation.link.textColor", "#FFFFFF")
    const style = {
      backgroundColor: _.get(window.settings, "brand.navigation['link--active'].backgroundColor")
    }
    const { mobileMenuOpen } = this.state;
    if(menuItem.url === '/subnav') menuItem.url = ""
    return (
      <div className={`menu-dropdown-container` + (!_.isEmpty(menuItem.items) ? ' sub-menu-items' : '')} key={key}>
        {menuItem.url ? (
          <span className={mobileMenuOpen ? 'navigation-link' : ''}>
            <a
              className={(!mobileMenuOpen ? 'navigation-link' : '') + (!_.isEmpty(menuItem.items) && !mobileMenuOpen ? ' icon-container' : '')}
              style={active ? style : {}}
              href={menuItem.url}
              target={menuItem.newTab ? "_blank" : "_self"}
            >
              <span>{localizedTitle}</span>
              {(!_.isEmpty(menuItem.items) && !mobileMenuOpen) && <TriangleIcon className="icon-triangle" color={linkColor} />}
            </a>
            {!_.isEmpty(menuItem.items) && mobileMenuOpen &&
              <DropdownIcon
                className="icon-triangle"
                open={this.isSubmenuOpen(menuItem.title)}
                color={linkColor}
                toggle={this.toggleMobileSubmenu(menuItem.title)}
              />}
          </span>
        ) : (
          <span className={`navigation-link` + (!_.isEmpty(menuItem.items) && !mobileMenuOpen ? ' icon-container' : '')} style={active ? style : {}}>
            <span>{localizedTitle}</span>
            {(!_.isEmpty(menuItem.items) && !mobileMenuOpen) && <TriangleIcon className='icon-triangle' color={linkColor}/>}
            {!_.isEmpty(menuItem.items) && mobileMenuOpen &&
              <DropdownIcon
                className="icon-triangle"
                open={this.isSubmenuOpen(menuItem.title)}
                color={linkColor}
                toggle={this.toggleMobileSubmenu(menuItem.title)}
              />}
          </span>
        )}
        { !_.isEmpty(menuItem.items) && (
          <div className={`nav-dropdown-list-container ${this.isSubmenuOpen(menuItem.title) ? 'nav-submenu-open' : 'nav-submenu-closed'}`}>
            { menuItem.items.map((object, i) => (
              <div className='navigation-link' key={i}>
                <a href={ object.url } target={object.newTab ? "_blank" : "_self"} className="dropdown-sub-link">
                  { object.icon && 
                    <img className="dropdown-icon" src={object.icon} alt={object.title}/>
                  }
                  <span>{ localizeTitle(object) }</span>
                </a>
              </div>
            )) }
          </div>
        ) }
      </div>
    )
  }

  renderUserMenu(menuItem, key) {
    const localizedTitle = localizeTitle(menuItem);
    const ifLogin = menuItem.title.toLowerCase().indexOf('log in') > -1
    return ifLogin ? (
      <div className={"menu-dropdown-container " + (menuItem.accessLevels.loggedOut ? 'hide' : 'show')} key={key}>
        <div className="navigation-link" onClick={evt => { popup.login() }}><span>{localizedTitle}</span></div>
      </div>
    ) : (
      <div className={"menu-dropdown-container " + (menuItem.accessLevels.loggedOut ? 'hide' : 'show')} key={key}>
        <a className="navigation-link" href={menuItem.url}><span>{localizedTitle}</span></a>
      </div>
    )
  }

  toggleMobileMenu() {
    document.documentElement.style.overflow = !this.state.mobileMenuOpen ? 'hidden' : 'initial'
    this.setState({ mobileMenuOpen: !this.state.mobileMenuOpen })
  }

  controlButtons() {
    if (window.SERVER_SIDE_RENDERING) return;

    const isSvod = this.state.model === 'SVOD'
    if ( getQueryVariable('refreshUser') && !(this.state.user)){
        return null
    }
    return (
      <div className={'controls ' + (this.state.mobileMenuOpen ? 'move' : '')}>
        <div className="search-icon" onClick={ this.handleSearch() } >
          { !this.props.filtersSearch && <i className="navigation-link ion-ios-search-strong" /> }
        </div>
        { this.renderLanguageDropdown() }
        { !isSvod && ( this.state.user ? this.userButtons() : this.loginButton()) }
        { isSvod && !this.state.user && this.loginButton(false) }
        { isSvod && !(this.state.user && this.state.user.isSubscribed) && this.subscribeButton() }
        { isSvod && this.state.user && this.userButtons() }
      </div>
    )
  }

  userButtons() {
    const checkUserAccessLevel = accessLevelCheck(this.state.user)
    var name = this.state.user.name || this.state.user.email.split('@')[0]
    return (
      <div className="user-buttons">
        <div className="navigation-link greeting">
          <span className="hello"> Hello,</span> <br />
          <span className="name"> { name } </span>
        </div>
        {(this.state.user && this.state.user.image) &&
          <div className="user-image-container">
            <img src={ this.state.user.picture || avatar} alt="avatar" />
          </div>
        }
        <div className="dropdown">
          { _.map(this.state.userLinks.filter(checkUserAccessLevel), (v, k) => {
            return (
              <a className={(v.title.toLowerCase().indexOf('log in') > -1)} href={ v.url } key={ k } >{ localizeTitle(v) }</a>
            )
          }) }
          <a href="#logout" onClick={ e => this.onLogoutClick(e) }>Log Out</a>
        </div>
      </div>
    )
  }

  loginButton(fill) {
    return (
      <button
        onClick={ evt => { popup.login() } }
        className={ `${fill ? 'cta ' : ''}login-button navigation-link` }> Login
      </button>
    )
  }

  subscribeButton() {
    if (this.primaryCta.placement === "Masthead" && !window.settings.forceLogin) {
     return (
        <a href={this.primaryCta.url} className="cta subscribe-button">{localizeCtaText(this.primaryCta)}</a>
      )
    }
  }

  displayBanner(){
      var classNames = this.primaryCta.placement === 'Banner' ? 'banner site-background-color' : 'cta subscribe-button'
      if (this.state.mobileMenuOpen)
        classNames += ' move'

      return(
        <div className={classNames}>
          <a
            href={this.primaryCta.url}
            className="banner-url"
            onClick={ () => this.pushButtonEvent('banner') }
          >
            <span className="banner-text">{ localizeBannerText(this.primaryCta) }</span>
            <span className="cta-text">{ localizeCtaText(this.primaryCta) }</span>
          </a>
        </div>
      )
  }

  // source: masthead_button || banner || video_wall
  pushButtonEvent(source) {
    if (!window.dataLayer)
      return

    window.dataLayer.push({
      'event': 'subscribe_cta_click',
      'source': source
    })
  }

  onLogoutClick(evt) {
    evt.preventDefault()
    logout().then(_ => {
      logoutUser()
    })
  }

  render() {
    const { isCollapsed } = this.props.layout.settings
    if (!window.SERVER_SIDE_RENDERING && window.sessionStorage && !window.sessionStorage.getItem('isApp')) {
      return (
        <nav className={`masthead ${isCollapsed ? 'isCollapsed' : ''} ${this.props.filtersSearch ? 'masthead-filter' : ''}`} ref={div => { this.masthead = div }}>
          <div className="masthead-container">
            {this.renderMasthead()}
            {this.props.filtersSearch && <SearchFilterSlideIn isOpen={this.state.searchFiltersOpen} toggleMenu={this.toggleFilterMenu} />}
            {this.shouldRenderBanner() && this.displayBanner()}
          </div>
        </nav>
      )
    } else {
      return (<nav></nav>)
    }
  }
}

connect(Masthead01, (state) => ({ user: state.user }), userStore)

export default Masthead01;
